import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";

import { StyledSection } from "./styles";

function SocialMediaIcons() {

    return ( 
        <StyledSection>
            <a href="https://github.com/brunopassos" target={"_blank"}>
                <AiFillGithub className="socialMediaIcon"/>
            </a>
            <a href="https://www.linkedin.com/in/bruno-passosbp/" target={"_blank"}>
                <AiFillLinkedin className="socialMediaIcon"/>
            </a>
        </StyledSection>
     );
}

export default SocialMediaIcons;